export function createMotivoRechazo() {
  return {
    Tipo: '',
    Clave: '',
    EmpresaId: 0,
    Nombre: '',
    EsActivo: true
  };
}
